import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Header from '@/components/header';
import Hero from '@/components/hero';
import Home from '@/views/home/home';
import Footer from '@/components/footer';
import Search from '@/views/search/search';
import Discover from '@/views/discover/discover';
import Explore from '@/views/explore/explore';
import BotEventCatcher from '@/components/botEventCatcher';


import './fonts/Titillium_Web/TitilliumWeb-Regular.ttf';
import './fonts/Titillium_Web/TitilliumWeb-SemiBold.ttf';
import './fonts/Titillium_Web/TitilliumWeb-Bold.ttf';

class App extends React.Component {

  constructor(props) {
    super(props);
    console.log(props)
    this.state = { 
      couseSearch: '',
      injectedFilters: {}
    }
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.injectFilters = this.injectFilters.bind(this);
  }

  handleSearchChange(event) {
    this.setState({courseSearch: event.target.value});    
  }
  injectFilters(filters){
    this.setState({injectedFilters: filters});
    //history.push("/rechercher");
  }

  render() {
    return (
      <Router>
        <main className="text-gray-darkest font-t-regular bg-khaki-light flex flex-col min-h-full">
          <Header />
          <Switch>
            <Route path="/explorer">
              <Explore />
            </Route>
            <Route path="/rechercher">
              <Search handleSearchChange={this.handleSearchChange} searchValue={this.state.courseSearch} injectedFilters={this.state.injectedFilters} />
            </Route>
            <Route path="/decouvrir">
              <Hero />
              <Discover />
            </Route>
            <Route path="/">
              <Hero />
              <Home handleSearchChange={this.handleSearchChange} />
            </Route>
          </Switch>
          <Footer />
          <BotEventCatcher injectFilters={this.injectFilters}/>
      </main>
      </Router>
    );
  }
}

export default App;
